/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SchedulingDetails {
    getFixupPrototypeFunction() { return SchedulingDetails.fixupPrototype; }

    static newInstance(model: Partial<SchedulingDetails>): SchedulingDetails {
        let obj = Object.assign(new SchedulingDetails(), model);
        SchedulingDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SchedulingDetails>): SchedulingDetails {
        if (!model) return null;
        return SchedulingDetails.newInstance(<SchedulingDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SchedulingDetails) {
        if (!obj) return;

        models.SchedulingDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SchedulingDetails): boolean {
        Object.setPrototypeOf(obj, SchedulingDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.time) {
            models.SchedulingTimeDetails.fixupPrototype(this.time);
        }
        if (this.dayofmonth) {
            models.SchedulingDayDetails.fixupPrototype(this.dayofmonth);
        }
        if (this.weekday) {
            models.SchedulingDayDetails.fixupPrototype(this.weekday);
        }
    }

    /**
     * Month when the given category is scheduled to run. Allowed values: 1-12 or JAN-DEC
     */
    month: string;

    /**
     * Time when the given category is scheduled to run.
     */
    time: models.SchedulingTimeDetails;

    /**
     * At which day of that month the given category is scheduled to run. Note: If both weekday and dayofmonth are specified, dayofmonth takes precedence.
     */
    dayofmonth: models.SchedulingDayDetails;

    /**
     * At which day of that week the given category is scheduled to run. Note: If both weekday and dayofmonth are specified, dayofmonth takes precedence.
     */
    weekday: models.SchedulingDayDetails;

    /**
     * Year when the given category is scheduled to run. Example:'2024-2099'
     */
    year: string;

}
